import { createSelector } from 'reselect'

/**
 * Direct selector to the app state domain
 */
export const selectDomain = () => (state) => state.keywordLists

export const selectKeywordLists = () =>
  createSelector(selectDomain(), (substate) => substate.lists)

export const selectIsLoadingKeywordLists = () =>
  createSelector(selectDomain(), (substate) => substate.isLoadingKeywordLists)

export const selectCurrentList = () =>
  createSelector(selectDomain(), (substate) => substate.currentList)

export const selectIsLoadingKeywords = () =>
  createSelector(selectDomain(), (substate) => substate.isLoadingKeywords)

export const selectIsLoadingKeywordLocations = () =>
  createSelector(
    selectDomain(),
    (substate) => substate.isLoadingKeywordLocations,
  )
